import revOppsConstants from "constants/RevenueOpportunity";
import tagConstants from "constants/Tag";
import { FORM_MODES } from "routes/revenue_opportunity/form/defaults";

export const MODEL_TYPE = "RevenueOpportunity";
export const TAG_MODEL_TYPE = tagConstants.taggableModels.revenue_opportunity;

export const PAGE_TITLES = {
  [FORM_MODES.create]: "Create Revenue Opportunity",
  [FORM_MODES.edit]: "Edit Revenue Opportunity",
  [FORM_MODES.clone]: "Clone Revenue Opportunity",
};

export const BREADCRUMB_LABELS = {
  [FORM_MODES.create]: "New",
  [FORM_MODES.edit]: "Edit",
  [FORM_MODES.clone]: "Clone",
};

export const SUCCESS_MESSAGES = {
  [FORM_MODES.create]: "Revenue Opportunity created",
  [FORM_MODES.edit]: "Revenue Opportunity updated",
  [FORM_MODES.clone]: "Revenue Opportunity cloned",
};

export const RECIPIENT_TYPE_OPTIONS = Object.values(
  revOppsConstants.recipientType
).map(value => ({
  key: value,
  value,
  text: value.charAt(0).toUpperCase() + value.slice(1),
}));
